<template>
  <transition name="fade">
    <div v-show="visible" class="notification" :style="style" @click="click">
      <i class="notification__icon el-icon-warning"></i>
      <div class="content">
        <h2>{{ title }}</h2>
        <p>{{ message }}</p>
      </div>
      <a class="btn el-icon-close" @click.stop="close"></a>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Notification',
  // props: {
  //   message: {
  //     type: String,
  //     require: true
  //   },
  //   title: {
  //     type: String,
  //     require: true
  //   }
  // },
  data() {
    return {
      title: '',
      message: '',
      visible: false,
      closed: false,
      onClose: null,
      onClick: null,
    }
  },
  computed: {
    style() {
      return {}
    },
    verticalProperty() {
      return 'bottom';
    },
  },
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      }
    }
  },
  methods: {
    destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    click() {
      if (typeof this.onClick === 'function') {
        this.onClick();
      }
    },
    close() {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose();
      }
    },
    keydown(e) {
      if (e.keyCode === 27) { // esc关闭消息
        if (!this.closed) {
          this.close();
        }
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.keydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keydown);
  }
}
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  width: 330px;
  padding: 14px 26px 14px 13px;
  border-radius: 8px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  position: fixed;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  -webkit-transition: opacity 0.3s, left 0.3s, right 0.3s, top 0.4s, bottom 0.3s,
    -webkit-transform 0.3s;

  transition: opacity 0.3s, transform 0.3s, left 0.3s, right 0.3s, top 0.4s,
    bottom 0.3s, -webkit-transform 0.3s;
  overflow: hidden;
  .notification__icon {
    height: 24px;
    width: 24px;
    font-size: 24px;
    color: #e6a23c;
    flex-shrink: 0;
  }
  h2 {
    font-weight: 700;
    font-size: 16px;
    color: #303133;
    margin: 0;
  }
  .content {
    margin-left: 13px;
    margin-right: 8px;
    flex-shrink: 0;
    width: 240px;
    h2 {
      line-height: 18px;
    }
    p {
      font-size: 14px;
      line-height: 21px;
      margin: 6px 0 0;
      color: #606266;
      text-align: justify;
    }
  }
  .btn {
    height: 24px;
    width: 24px;
    flex-shrink: 0;
    color: #909399;
  }
}
</style>